import React from 'react';
import TextLink from './TextLink';

function SpotlightInternalLink({ item }) {
    return (
        <li className='spotlight__item'  style={{
            backgroundImage: `url(${item.images.thumbnail})`,
        }}>
            <a className="spotlight__link" href={`${window.location.protocol}//${window.location.host}/news/${item.article_post_id}`} target="_self">
                <div className='spotlight__content'>
                    { (item.category !== null) && <h6 className='spotlight__category'>{item.category.name}</h6> }
                    <h5 className='spotlight__title'>{item.title}</h5>
                </div>
                <TextLink type="readmore" text="Read More" />
            </a>
        </li>
    )
}

export default SpotlightInternalLink;
